<template>
  <el-dialog
    :visible="!!editingProject"
    title="修改设置"
    width="1000px"
    @close="closeDialog"
  >
    <el-form :model="detail" ref="form" :rules="rules" label-width="150px">
      <el-form-item label="借贷币种：" prop="borrowCoinType">
        <span>{{ detail.borrowCoinType }}</span>
      </el-form-item>
      <el-form-item label="抵押币种：" prop="mortgageCoinType">
        <span>{{ detail.mortgageCoinType }}</span>
      </el-form-item>
      <el-form-item label="借贷比例：" prop="borrowingMortgageScale">
        <el-input-number
          v-model="detail.borrowingMortgageScale"
          :min="0"
          :max="1"
          :step="0.1"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="爆仓比例：" prop="burstScale">
        <el-input-number
          v-model="detail.burstScale"
          :min="0"
          :step="0.1"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="警告比例：" prop="warnScale">
        <el-input-number
          v-model="detail.warnScale"
          :min="0"
          :step="0.1"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="最小抵押数量：" prop="minMortgageAmount">
        <el-input-number v-model="detail.minMortgageAmount"></el-input-number>
      </el-form-item>
      <el-form-item label="抵押精度：" prop="mortgagePrecision">
        <el-input-number v-model="detail.mortgagePrecision"></el-input-number>
      </el-form-item>
      <el-form-item label="借币精度：" prop="borrowPrecision">
        <el-input-number v-model="detail.borrowPrecision"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'cornucopiaDetail',
  data() {
    return {
      detail: {},
      rules: {
        borrowingMortgageScale: {
          required: true,
          message: '请填写'
        },
        burstScale: {
          required: true,
          message: '请填写'
        },
        warnScale: {
          required: true,
          message: '请填写'
        },
        minMortgageAmount: {
          required: true,
          message: '请填写'
        },
        mortgagePrecision: {
          required: true,
          message: '请填写'
        },
        borrowPrecision: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  computed: {
    ...mapState('mortgage', ['coinTypeList', 'editingProject'])
  },
  watch: {
    editingProject(val) {
      this.detail = {
        ...val
      };
    }
  },
  components: {},
  methods: {
    ...mapMutations('mortgage', ['setEditingProject']),
    ...mapActions('mortgage', ['update']),
    closeDialog() {
      this.setEditingProject(null);
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      const submitData = {
        id: this.detail.id,
        borrowCoinType: this.detail.borrowCoinType,
        mortgageCoinType: this.detail.mortgageCoinType,
        borrowingMortgageScale: this.detail.borrowingMortgageScale,
        burstScale: this.detail.burstScale,
        warnScale: this.detail.warnScale,
        minMortgageAmount: this.detail.minMortgageAmount,
        mortgagePrecision: this.detail.mortgagePrecision,
        borrowPrecision: this.detail.borrowPrecision
      };
      this.update(submitData).then(() => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh');
      });
    }
  }
};
</script>
